import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-reuse mr-2.5 text-medium" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_outline_button, {
      type: "outline",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reuseClick')))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(_toDisplayString(_ctx.$t('proposal.list.content.table.body.actions.reuse')), 1)
      ]),
      _: 1
    })
  ]))
}